import { formatDistanceToNowStrict } from 'date-fns';
import { enUS, es } from 'date-fns/locale';

const locales = { en: enUS, es };

/**
 * Format timestamp to short format (e.g. "5h" instead of "5 hours")
 */
export function formatShortTimestamp(
  date: Date | any,
  locale: 'en' | 'es' = 'en',
  addSuffix = false
): string {
  // Handle Firestore Timestamp or Date object
  const dateObj = typeof date?.toDate === 'function' ? date.toDate() : new Date(date);
  
  if (!dateObj || isNaN(dateObj.getTime())) return '';

  const distance = formatDistanceToNowStrict(dateObj, {
    addSuffix: false,
    locale: locales[locale],
  });

  // Convert to short format
  let short = distance
    .replace(' seconds', 's')
    .replace(' second', 's')
    .replace(' minutes', 'm')
    .replace(' minute', 'm')
    .replace(' hours', 'h')
    .replace(' hour', 'h')
    .replace(' days', 'd')
    .replace(' day', 'd')
    .replace(' months', 'mo')
    .replace(' month', 'mo')
    .replace(' years', 'y')
    .replace(' year', 'y')
    // Spanish
    .replace(' segundos', 's')
    .replace(' segundo', 's')
    .replace(' minutos', 'm')
    .replace(' minuto', 'm')
    .replace(' horas', 'h')
    .replace(' hora', 'h')
    .replace(' días', 'd')
    .replace(' día', 'd')
    .replace(' meses', 'mo')
    .replace(' mes', 'mo')
    .replace(' años', 'y')
    .replace(' año', 'y');

  if (addSuffix) {
    return locale === 'es' ? `hace ${short}` : `${short} ago`;
  }

  return short;
}
